import { Heading, SimpleGrid, Stack, Text } from '@chakra-ui/react';
import { LooseObject } from 'api/types';
import { useUserContext } from 'context/UserContextProvider';
import useControllingHistoricalQuery from 'hooks/useControllingHistoricalQuery';
import useControllingKpisQuery from 'hooks/useControllingKpisQuery';
import useControllingPendingQuery from 'hooks/useControllingPendingQuery';
import { useTranslation } from 'react-i18next';

import { KpiSubmittedVsCompleted } from '../../components/controlling/KpiSubmittedVsCompleted';
import { PendingStatusVsUser } from '../../components/controlling/PendingStatusVsUser';
import { LoadingSpinner } from '../../components/LoadingSpinner';
import useUsersQuery from '../../hooks/useUsersQuery';
import { ContentLayout } from '../../layout/ContentLayout';
import PageMetatags from '../../layout/PageMetatags';

const UtilizationPage = () => {
  const { t } = useTranslation();
  const { statusCodes } = useUserContext();
  const userQuery = useUsersQuery();

  const pendingQuery = useControllingPendingQuery();
  const kpisQuery = useControllingKpisQuery();
  const historicalQuery = useControllingHistoricalQuery();

  const historicalData: LooseObject = historicalQuery.data?.service_record || {};

  if (
    kpisQuery.isLoading ||
    historicalQuery.isLoading ||
    pendingQuery.isLoading ||
    kpisQuery.isFetching ||
    historicalQuery.isFetching ||
    pendingQuery.isFetching
  ) {
    return <LoadingSpinner />;
  }
  return (
    <ContentLayout>
      <PageMetatags title={t('pages:controlling.meta.title')} />
      <Heading size={'md'}>{t('pages:controlling.operations.title')}</Heading>

      <SimpleGrid columns={{ sm: 1, md: 4 }} spacing={4}>
        <KpiSubmittedVsCompleted title={t('service_record:label')} data={kpisQuery.data?.service_record || {}} />
        <KpiSubmittedVsCompleted title={t('service_history_request:label')} data={kpisQuery.data?.service_history_request || {}} />
        <KpiSubmittedVsCompleted title={t('workshop_verification_request:label')} data={kpisQuery.data?.verifications || {}} />
        <KpiSubmittedVsCompleted title={t('workshop_update_request:label')} data={kpisQuery.data?.workshop_data_updates || {}} />
      </SimpleGrid>

      <SimpleGrid columns={1} spacing={1}>
        <PendingStatusVsUser
          statusKey={'service_record'}
          data={pendingQuery.data?.service_record || {}}
          statusCodes={statusCodes}
          users={userQuery.data ?? []}
          subContent={
            !historicalQuery.isLoading ? (
              <Stack>
                <Text>
                  {t('controlling:historical.pending_on_sunday_vs_submitted_last_week')}: {historicalData?.pending_on_sunday} /
                  {historicalData?.submitted_last_week}
                </Text>
                <Text>
                  {t('controlling:historical.pending_on_sunday_vs_pending_start_last_week')}: {historicalData?.pending_on_sunday} /
                  {historicalData?.pending_start_last_week}
                </Text>
                <Text>
                  {t('controlling:historical.pending_yesterday_vs_submitted_last_month')}:{' '}
                  {historicalData?.submitted_last_month > 0
                    ? Number((historicalData?.pending_yesterday / historicalData?.submitted_last_month) * 100).toFixed(2)
                    : 0}{' '}
                  %
                </Text>
              </Stack>
            ) : null
          }
        ></PendingStatusVsUser>
        <PendingStatusVsUser
          statusKey={'service_history_request'}
          data={pendingQuery.data?.service_history_request || {}}
          statusCodes={statusCodes}
          users={userQuery.data ?? []}
        />
        <PendingStatusVsUser
          statusKey={'workshop_verification_request'}
          data={pendingQuery.data?.workshop_verification_request || {}}
          statusCodes={statusCodes}
          users={userQuery.data ?? []}
        />
        <PendingStatusVsUser
          statusKey={'workshop_update_request'}
          data={pendingQuery.data?.workshop_update_request || {}}
          statusCodes={statusCodes}
          users={userQuery.data ?? []}
        />
      </SimpleGrid>
    </ContentLayout>
  );
};

export default UtilizationPage;
